<template>
    <ag-grid-vue
        class="ag-theme-alpine landscape-details-grid"
        row-class="landscape-details-grid-row"
        :columnDefs="columnDefs"
        :rowData="params?.data?.detail"
        :row-selection="params?.masterSelected ? 'single' : undefined"
        @row-selected="onRowSelected"
        :suppress-context-menu="true"
        suppress-cell-focus="true"
        dom-layout="autoHeight"
    />
</template>

<script lang="ts">
import { AgGridVue } from "ag-grid-vue3";
import { LicenseManager } from "ag-grid-enterprise";
import { LicenseUtil } from "@/LicenseUtil";
import "ag-grid-enterprise";
import { GridApi } from "ag-grid-community";
import AlmStatusBadge from "@/components/pages/landscape/AlmStatusBadge.vue";
import AlmSwitchRenderer from "@/components/pages/landscape/AlmSwitchRenderer.vue";
import AlmCustomHeader from "@/components/pages/landscape/AlmCustomHeader.vue";
import { FormatDateTime } from "@/utils/Utils";
import { mapMutations } from "vuex";

export default {
    name: "DetailRendererComponent",
    components: {
        AgGridVue,
    },
    props: {
        params: Object,
    },
    data() {
        return {
            gridApi: {} as GridApi,
            columnDefs: [
                {
                    headerName: "Tenant",
                    field: "tenant",
                    flex: 3,
                    sortable: true,
                    resizable: false,
                    suppressHeaderMenuButton: true,
                    suppressColumnsToolPanel: true,
                },
                {
                    headerName: "Last deployed",
                    field: "lastDeployed",
                    flex: 1,
                    sortable: true,
                    resizable: false,
                    suppressHeaderMenuButton: true,
                    suppressColumnsToolPanel: true,
                    valueFormatter: (params: any) => {
                        return params.value ? FormatDateTime(params.value) : "Never deployed";
                    },
                },
                {
                    headerName: "Include?",
                    field: "include",
                    headerComponent: AlmCustomHeader,
                    headerComponentParams: {
                        displayName: "Include?",
                    },
                    cellRenderer: AlmSwitchRenderer,
                    cellStyle: { "text-align": "center" },
                    sortable: false,
                    resizable: false,
                    suppressHeaderMenuButton: true,
                    suppressColumnsToolPanel: true,
                },
                {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: AlmStatusBadge,
                    cellRendererParams: () => {
                        return {
                            showBorder: false,
                        };
                    },
                    sortable: true,
                    resizable: false,
                    suppressHeaderMenuButton: true,
                    suppressColumnsToolPanel: true,
                },
            ],
        };
    },
    async mounted() {
        const licenseUtil = new LicenseUtil();
        LicenseManager.setLicenseKey(licenseUtil.agGridLicense);
    },
    methods: {
        ...mapMutations('alm', [
            'setSelectedAlmTargetTenant',
        ]),
        onRowSelected(event: any) {
            try {
                    this.setSelectedAlmTargetTenant(event?.api?.getSelectedRows()?.[0] || {});
                }
                catch (e) {
                    console.error(e);
                }
        },
    },
};
</script>

<style scoped>
.landscape-details-grid {
    --ag-odd-row-background-color: none;
    --ag-borders: none;
    --ag-row-border-color: var(--accent-color-blue-12);
    --ag-checkbox-checked-color: var(--accent-color-blue);
    --ag-checkbox-indeterminate-color: var(--accent-color-blue);
    --ag-input-focus-box-shadow: none;
    --ag-icon-size: 20px;
    --ag-cell-horizontal-padding: 16px;
    --ag-border-radius: 2px;
    --ag-icon-font-color: var(--accent-color5);
}

.landscape-details-grid {
    padding-bottom: 16px;
    width: 100%;
    border: none;
}

.landscape-details-grid :deep(.ag-center-cols-viewport) {
    min-height: unset !important;
}

:deep(.landscape-details-grid-row) {
    border-bottom: none;
    border-top: var(--ag-row-border-style) var(--ag-row-border-color) var(--ag-row-border-width);
}

.landscape-details-grid :deep(.ag-column-first) {
    padding-left: 90px;
    padding-right: 0px;
}

.landscape-details-grid :deep(.ag-header-cell-comp-wrapper) {
    justify-content: center;
}
</style>
